<template>
  <ul class="statisInfo">
    <li class="statis_item">
      <div class="imgs">
        <img src="./unit.png" />
      </div>
      <div class="item_info">
        <span class="num">{{ statisData.unitNum }}<em>家</em></span>
        <span class="name">单位数量</span>
      </div>
    </li>
    <li class="statis_item">
      <div class="imgs">
        <img src="./device.png" />
      </div>
      <div class="item_info">
        <span class="num">{{ statisData.handDeviceNum }}<em>台</em></span>
        <span class="name">手动设备数量</span>
      </div>
    </li>
    <li class="statis_item">
      <div class="imgs">
        <img src="./change.png" />
      </div>
      <div class="item_info">
        <span class="num">{{ statisData.handChangeNum }}<em>次</em></span>
        <span class="name">手动切换次数</span>
      </div>
    </li>
    <li class="statis_item">
      <div class="imgs">
        <img src="./statis.png" />
      </div>
      <div class="item_info">
        <span class="num"
          >{{ statisData.reportNum }}<span>{{ statisData.reportRate }}%</span></span
        >
        <span class="name">报备统计/报备率</span>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      areaId: {
        type: String | Number
      }
    },
    data() {
      return {
        statisData: {},
        timer: null
      }
    },
    watch: {
      areaId: {
        handler(val) {
          this.getData()
          this.startTimer()
        },
        immediate: true
      }
    },
    methods: {
      getData() {
        this.$axiospost('operation/automatic/hand/detection/queryTopStatics', {
          parentAreaId: this.areaId
        }).then(res => {
          if (res.data.status == 10000) {
            this.statisData = res.data.data
          }
        })
      },
      // 新增：启动定时器
      startTimer() {
        this.stopTimer() // 先清除可能存在的定时器
        this.timer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 新增：停止定时器
      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.stopTimer)
    }
  }
</script>

<style lang="less" scoped>
  .statisInfo {
    position: absolute;
    top: 12.61vh;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;

    .statis_item {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-right: 0.3rem;
      }

      .imgs {
        width: 0.77rem;
        font-size: 0;

        img {
          width: 100%;
          height: auto;
        }
      }

      .item_info {
        display: flex;
        flex-direction: column;
        align-items: center;

        .num {
          min-width: 1.08rem;
          height: 2.97vh;
          display: inline-block;
          font-family: MicrosoftYaHei;
          font-size: 2.41vh;
          font-weight: bold;
          color: #fff;
          text-align: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          line-height: 0.76;

          em {
            margin-left: 0.02rem;
            line-height: 2.97vh;
            font-family: MicrosoftYaHei;
            font-weight: normal;
            font-size: 1.3vh;
            color: #fff;
          }

          span {
            margin-left: 0.08rem;
            font-weight: normal;
            font-size: 1.48vh;
            color: #fff;
          }
        }

        .name {
          font-family: MicrosoftYaHei;
          font-size: 1.3vh;
          color: #fff;
        }
      }

      &:first-child {
        .num {
          background-image: url('./unit_bg.png');
        }
      }

      &:nth-child(2) {
        .num {
          background-image: url('./sd_bg.png');
        }
      }

      &:nth-child(3) {
        .num {
          background-image: url('./change_bg.png');
        }
      }

      &:last-child {
        .num {
          background-image: url('./statis_bg.png');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/middleTop/index.vue